import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../../redux/SettingAction";
import { Overlay } from "../../../common/components/Overlay";
import { FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

export const AddReferral = () => {
  const [swalProps, setSwalProps] = useState({});
  const [referralCode, setReferralCode] = useState("");
  const intl = useIntl();
  const dispatch = useDispatch();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        backgroundImage: `url(${process.env.PUBLIC_URL}/image/homebackground.avif)`,
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={styles.navBar}>
        <div style={styles.backButton}>
          <Link to="/setting/profile">
            <FiArrowLeft style={{ color: "white" }} />
          </Link>
        </div>
        <div style={styles.title} className="text-font4">
          {intl.formatMessage({ id: "addReferral" })}
        </div>
      </div>
      {settingState.actionsLoading && <Overlay />}
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div style={{ padding: "20px", color: "white" }}>
        <form onSubmit={handleSubmit}>
          <label className="me-2 text-nowrap">
            {intl.formatMessage({ id: "referralCode" })}:
          </label>
          <input
            className="mb-2"
            value={referralCode}
            onChange={(e) => {
              const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
              setReferralCode(value);
            }}
            placeholder={intl.formatMessage({ id: "referralCode" })}
            style={{
              background: "#1c1e23",
              width: "100%",
              height: 35,
              borderRadius: 5,
              paddingLeft: "5%",
              paddingRight: "5%",
              boxSizing: "border-box",
              color: "white",
            }}
          />
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "5px",
              backgroundColor: "#f5be09",
              color: "#000",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {intl.formatMessage({ id: "submit" })}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
